// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ff270a66","239":"ab0efbbb","455":"b4b2ac1b"}[chunkId] + ".chunk.js";
};